import { useState } from 'react';
import { useDevedor } from '../../../context/ConsultContext';
import { useInvoicesTable } from '../../../context/TableContext';
import { useLoading } from '../../../hooks/useLoading';
import { api } from '../../../services/api';
import { Loader } from '../../Loader/Loader';
import {
  Button,
  Container,
  Exit,
  InputBlock,
  ModalBody,
  ModalContainer,
  ModalTitle,
  TextArea,
} from './styles';

export const DeleteModal = () => {
  const {
    openDeleteModal,
    isParcela,
    idParcela,
    page,
    faturaParcela,
    faturaParcelas,
    listarFaturas,
    setTableSelected,
    setShowTable,
  } = useInvoicesTable();
  const { cpf } = useDevedor();

  const [observacao, setObservacao] = useState('');
  const [servico, setServico] = useState('');

  const { hideLoader, showLoader, loader } = useLoading();

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (page === 'register') {
      showLoader();
      if (isParcela) {
        const index = faturaParcela.parcelas.findIndex(
          (parcela) => parcela.nroparc === idParcela.nroparc,
        );

        faturaParcela.parcelas.splice(index, 1);
      } else {
        showLoader();
        const index = faturaParcelas.findIndex(
          (fatura) =>
            fatura.fatura.documento === faturaParcela.fatura.documento,
        );
        faturaParcelas.splice(index, 1);
        setTableSelected(0);
        setShowTable(false);
      }
    } else {
      if (isParcela && idParcela.valorParcela) {
        showLoader();

        const response = await api.delete(`parcela/desativar`, {
          data: {
            observacao: observacao ? observacao : 'Parcela',
            servico: servico,
            documento: idParcela.documento,
            nroparc: idParcela.nroparc,
            cpf,
            valorFatura: faturaParcela.fatura.valorfatura,
            valorParcela: idParcela.valorParcela,
            qtdParcela: faturaParcela.fatura.qtdeparc,
            credor: '685',
          },
        });

        listarFaturas(response.data.faturas_parc.faturas_parc);
        setTableSelected(response.data.documento);
      } else {
        showLoader();
        const response = await api.delete(`fatura/desativar`, {
          data: {
            documento: faturaParcela.fatura.documento,
            cpf,
            observacao: observacao ? observacao : 'Fatura',
            servico: servico,
            valor: faturaParcela.fatura.valorfatura,
            credor: '685',
          },
        });

        listarFaturas(response.data.faturas_parc);
      }
    }
    openDeleteModal(undefined, undefined, undefined, false, undefined);

    hideLoader();
  }

  return (
    <Container>
      <ModalContainer>
        <Exit
          onClick={() =>
            openDeleteModal(faturaParcela, undefined, undefined, false)
          }
        >
          X
        </Exit>
        <ModalTitle>
          <p>
            Por favor informe o motivo pelo qual deseja excluir o débito acima
          </p>
        </ModalTitle>
        <ModalBody className="modal-body">
          <form onSubmit={handleSubmit}>
            <InputBlock>
              <div className="checkbox-input">
                <input
                  type="checkbox"
                  onChange={(e) => setServico('Pgto - Pendente de Baixa')}
                />
                <label htmlFor="">
                  Cliente realizou Pgto - Pendente de Baixa
                </label>
              </div>
            </InputBlock>

            <InputBlock>
              <div className="checkbox-input">
                <input
                  type="checkbox"
                  onChange={(e) => setServico('Pgto - Baixado')}
                />
                <label htmlFor="">Cliente realizou Pgto - Baixado</label>
              </div>
            </InputBlock>

            <InputBlock>
              <div className="checkbox-input">
                <input
                  type="checkbox"
                  onChange={(e) => setServico('Recusa a pagar')}
                />
                <label htmlFor="">Cliente recusa-se a pagar</label>
              </div>
            </InputBlock>

            <InputBlock>
              <div className="checkbox-input">
                <input
                  type="checkbox"
                  onChange={(e) => setServico('Ação judicial')}
                />
                <label htmlFor="">Cliente informa ação judicial</label>
              </div>
            </InputBlock>

            <InputBlock>
              <div className="checkbox-input">
                <input
                  type="checkbox"
                  onChange={(e) => setServico('Falecimento')}
                />
                <label htmlFor="">Falecimento do Cliente</label>
              </div>
            </InputBlock>

            <InputBlock>
              <TextArea
                placeholder="Descreva o motivo da exclusão"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                maxLength={100}
              />
            </InputBlock>

            <Button>
              <button type="submit">Excluir Débito</button>
            </Button>
          </form>
        </ModalBody>
      </ModalContainer>
      {loader && <Loader />}
    </Container>
  );
};
